<!-- 视频组件 -->
<template>
    <el-dialog class="audioPreview" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body :visible.sync="dialogVisible" width="60%">
        <div class="content" v-if="dialogVisible">
            <video :src="src" controls></video>
            <img :src="require('@/assets/measAssets/image/common/close.png')" @click="cancel" class="close" alt="">
            <img :src="require('@/assets/measAssets/image/common/audio.png')" class="audio_icon" alt="">
        </div>
    </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      src: ''
    }
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    open(url) {
      this.src = url
      this.dialogVisible = true
    },
    cancel() {
      this.dialogVisible = false
      this.src = ''
    }
  }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.audioPreview {
  .el-dialog {
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      border: none;
      .content {
        position: relative;
        max-height: 716px;
        background: #000000;
        video {
          width: 100%;
          height: 100%;
        }
        .close {
          width: 20px;
          height: 20px;
          color: #4b5660;
          position: absolute;
          right: -10px;
          top: -10px;
          cursor: pointer;
        }
        .audio_icon {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          width: 180px;
        }
      }
    }
  }
}
</style>